import React, { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import DotsLoader from 'shared/components/loaders/dots'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import styled from 'styled-components'
import SuperCutUploader from '../supercut/shared/utils/uploader'
import { FALLBACK_CLIP_TITLE } from '../../constants'
import { CreationToolsContext } from '../../manager'
import { CreationToolSourceFile } from '../../types'
import CreationTool from '../../types/creation-tool'
import CreationToolError from '../../types/error'
import CreationToolOutputType from '../../types/output-type'
import getSourceFrames from '../../utils/get-source-frames'
import getUnvalidatedSource from '../../utils/get-unvalidated-source'
import { validateSourceByOutput } from '../../utils/validate-source'
import { WrapperBlock } from '../blocks'
import ErrorModal from '../error-modal'

const Error = styled(ErrorModal)`
    box-shadow: 0 6px 9px rgba(0, 0, 0, 0.5);
    width: 400px;
`

const processImagingUrl = async (url: string, filename: string = FALLBACK_CLIP_TITLE): Promise<File> => {
    const blob = await fetch(url).then(response => response.blob())
    return new File([blob], filename, {
        type: blob.type,
        lastModified: Date.now(),
    })
}

const CreationToolsSupercut = () => {
    const { tool, setFiles } = useContext(CreationToolsContext)
    const { goBack } = useHistory()
    const [hasNoFiles, setHasNoFiles] = useState<boolean>(false)

    useAsyncEffect(async () => {
        const { urls = [], isClips, title } = SuperCutUploader.getUploadSessionData()
        const outputType = isClips ? CreationToolOutputType.Video : CreationToolOutputType.Gif
        const requiresFrameProcessing = CreationTool.requiresFrameProcessing(tool)

        if (!urls.length) {
            setHasNoFiles(true)
            return
        }

        const processedSources: CreationToolSourceFile[] = []

        for (let i = 0; i < urls.length; i++) {
            let source = urls[i]

            if (source.indexOf(`imaging.giphy.com`) > -1) {
                source = await processImagingUrl(source, source)
            }

            let processedFile: CreationToolSourceFile

            if (urls.length > 1) {
                processedFile = getUnvalidatedSource(source)
            } else {
                processedFile = await validateSourceByOutput(source, outputType)
            }

            if (requiresFrameProcessing) {
                const frames = await getSourceFrames(processedFile)
                processedFile.frames = frames
            }

            if (title) {
                processedFile.title = title
            }

            processedSources.push(processedFile)
        }

        SuperCutUploader.clearUploadSessionData()
        setFiles(processedSources, outputType, true)
    }, [])

    return hasNoFiles ? (
        <WrapperBlock>
            <Error
                {...{
                    error: CreationToolError.NoSuperCutFiles,
                    onGoBack: goBack,
                }}
            />
        </WrapperBlock>
    ) : (
        <DotsLoader isAbsolute />
    )
}

export default CreationToolsSupercut
